interface Indexed {
  readonly index: number;
}

const checkIfIsIndexed = (item: unknown): item is Indexed =>
  typeof item === 'object' &&
  item !== null &&
  typeof (item as Partial<Indexed>).index === 'number';

// The indexed items (the representatives) take their position in the list: a removal leaves no
// hole an addition would collide with.
export const withPositionIndexes = (items: readonly unknown[]): unknown[] =>
  items.map((item, index) =>
    checkIfIsIndexed(item) ? { ...item, index } : item,
  );
